export const PRODUCER_ZONE_URL_SEGMENT = 'strefa-producenta';

export const PAGE_LIMIT_ITEM = 36;

export const PRODUCER_LOGO_WIDTH = 64;
export const PRODUCER_LOGO_HEIGHT = 32;
export const MOBILE_PRODUCER_LOGO_WIDTH = 56;
export const MOBILE_PRODUCER_LOGO_HEIGHT = 28;
